import { FC, PropsWithChildren, ReactNode } from "react";

import {
  HeaderBottomCenterButtonsStyled,
  HeaderBottomStyled,
  HeaderButtonsRightWrapperStyled,
} from "./header-bottom.styled";

interface IHeaderBottomCustom extends PropsWithChildren {
  customRightContent?: ReactNode | null;
}

export const HeaderBottomCustom: FC<IHeaderBottomCustom> = ({
  customRightContent,
  children,
}) => {
  return (
    Boolean(customRightContent) && (
      <HeaderBottomStyled>
        <HeaderBottomCenterButtonsStyled>
          {children}
        </HeaderBottomCenterButtonsStyled>
        <HeaderButtonsRightWrapperStyled>
          {customRightContent}
        </HeaderButtonsRightWrapperStyled>
      </HeaderBottomStyled>
    )
  );
};
